module.exports = __webpack_public_path__ + "img/01-menu-bar-on_03.2146e7cb.png";